export default {
  id: 'teams_promote_content_shares_without_back_to_platform',
  title: 'Promote content shares (without back to platform button)',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_CONTENT' ],
  description: 'Send up to 4 selected pieces of content to your employees so they can easily share them across their network.',
  body: {
    attachments: [],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_CONTENT>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_CONTENT: id => `<attachment id='${id}'></attachment>`,
  },
  attachment(id, contentShareType = 'default') {
    let content = {};
    const generateContent = (items) => ({
      type: 'AdaptiveCard',
      version: '1.5',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      body: [
        {
          type: 'Container',
          separator: true,
          items: [
            {
              type: 'ColumnSet',
              columns: [
                {
                  type: 'Column',
                  width: 'stretch',
                  items: [
                    {
                      type: 'TextBlock',
                      text: '{{CONTENT_[ID]_TITLE}}',
                      wrap: true,
                      weight: 'Bolder',
                      size: 'Medium'
                    },
                    {
                      type: 'TextBlock',
                      text: '{{CONTENT_[ID]_DESCRIPTION}}',
                      wrap: true
                    }
                  ]
                },
                {
                  type: 'Column',
                  width: 'auto',
                  items: [
                    {
                      type: 'Image',
                      url: '{{CONTENT_[ID]_IMAGE_URL}}',
                      size: 'Medium',
                      altText: '{{CONTENT_[ID]_TITLE}}'
                    }
                  ]
                }
              ]
            },
            ...items
          ]
        },
      ],
      msTeams: {
        width: 'Full'
      }
    });
    if (contentShareType === 'linkedin-only') {
      content = generateContent([
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on LinkedIn',
              url: '{{CONTENT_[ID]_LINKEDIN_SHARE_LINK}}'
            }
          ]
        }
      ]);
    } else {
      content = generateContent([
        {
          type: 'TextBlock',
          text: 'Suggested Share Text:',
          wrap: true,
          weight: 'Bolder'
        },
        {
          type: 'TextBlock',
          text: '{{CONTENT_[ID]_SHARE_TEXT}}',
          wrap: true,
          isSubtle: true,
          spacing: 'Small'
        },
        {
          type: 'TextBlock',
          text: '👆 Copy the text above to share with your network',
          wrap: true,
          isSubtle: true,
          size: 'Small',
          spacing: 'Small'
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on LinkedIn',
              url: '{{CONTENT_[ID]_LINKEDIN_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Share on Facebook',
              url: '{{CONTENT_[ID]_FACEBOOK_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Share on X',
              url: '{{CONTENT_[ID]_TWITTER_SHARE_LINK}}'
            }
          ]
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on Messenger',
              url: '{{CONTENT_[ID]_MESSENGER_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Share on WhatsApp',
              url: '{{CONTENT_[ID]_WHATSAPP_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Copy Share Link',
              url: '{{CONTENT_[ID]_COPY_SHARE_LINK}}'
            }
          ]
        }
      ]);
    }
    const attachment = {
      id,
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify(content)
    };

    return attachment;
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following pieces of content with your network to win rewards! ...',
      defaultValue: 'Share the following pieces of content with your network to win rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteContentSharesWithNoBackToPlatform.js